import React from 'react';
import Canterano from '../homes/Canterano';
import Darsena from '../homes/Darsena';
import Yoga from '../homes/Yoga';

import canteranoTheme from '../themes/canterano';
import darsenaTheme from '../themes/darsena';
import yogaTheme from '../themes/yoga';

const getCustomization = () => {
  const custom = {
    homes: null,
    themes: null,
  };

  const PROJECT_ID = process.env.REACT_APP_PROJECT_ID;

  const homes = {
    'popular-payment-system': <Canterano />,
    'popular-canterano': <Canterano />,
    'popular-darsena-demo': <Darsena />,
    'popular-darsena': <Darsena />,
    'popular-yoga-demo': <Yoga />,
    'popular-yoga': <Yoga />,
  };

  const themes = {
    'popular-payment-system': canteranoTheme,
    'popular-canterano': canteranoTheme,
    'popular-darsena-demo': darsenaTheme,
    'popular-darsena': darsenaTheme,
    'popular-yoga-demo': yogaTheme,
    'popular-yoga': yogaTheme,
  };

  // const placeholdersMenu = {
  //   'popular-payment-system': '/images/placeholder_menu_canterano.png',
  //   'popular-canterano': '/images/placeholder_menu_canterano.png',
  //   'popular-darsena-demo': '/images/placeholder_menu_darsena.png',
  //   'popular-darsena':'/images/placeholder_menu_darsena.png',
  // };

  custom.home = homes[PROJECT_ID];
  custom.theme = themes[PROJECT_ID];

  return custom;
};
export default getCustomization;
